import ContractingFooter from "features/contracting/components/ContractingFooter";
import ContractingStepFormProps from "features/contracting/models/ContractingStepFormProps";
import { useContractingStep } from "features/contracting/hooks/useContractingStep";
import React from "react";
import { useSelector } from "react-redux";
import IAppState from "infrastructure/store/IAppState";
import ContractingState from "infrastructure/store/contracting/ContractingState";
import { useForm } from "features/shared/forms/hooks/useForm";
import ContractingProcessType from "features/contracting/components/process/ContractingProcessType";
import { TerminationOfExistingContract } from "features/contracting/enums/terminationOfExistingContract";
import _ from "lodash";
import { ContractingProcessAnswersMap } from "features/contracting/components/process/answers/ContractingProcessAnswersMap";
import { processFormValidations } from "./processFormValidation";
import ContractExpectedEffectiveDate from "features/contracting/components/process/ContractExpectedEffectiveDate";
import RenderWrapper from "features/shared/components/renderWrapper/RenderWrapper";
import { TerminationSchemeEnumDTO } from "features/shared/enums/dynamic/TerminationSchemeEnumDTO";
import InvoiceUploadSubForm from "features/contracting/components/process/InvoiceUploadSubForm";
import { isFilledProcessType, isInvoiceUploadType } from "./processFormHelper";

const ProcessFormSection = (props: ContractingStepFormProps) => {
  // store
  const stepData = useSelector<IAppState, ContractingState>(
    (store) => store.contracting
  ).progress.steps[props.actualStep.component];

  const configuration = useSelector<IAppState, ContractingState>(
    (store) => store.contracting
  ).configuration;

  const terminationSchemes: TerminationSchemeEnumDTO[] =
    configuration.terminationSchemes!;

  // form hook
  const formHandler = useForm({
    initialValues: stepData.values ?? undefined,
    initialValidations: processFormValidations(),
  });

  const { values, valideteForm, getFormValue } = {
    ...formHandler,
  };

  // form-step hook
  const { onPrevClick, onSaveClick, onNextClick } = useContractingStep({
    ...props,
    formValues: values,
    validateForm: valideteForm,
  });

  // helpers
  const getProcessType = () => {
    return getFormValue<TerminationOfExistingContract>(
      "terminationOfExistingContract"
    );
  };

  // sub-renders
  const renderProcessAnswerForm = () => {
    const processType = getProcessType();

    if (processType) {
      const AnswerForm = ContractingProcessAnswersMap[processType];

      if (AnswerForm !== undefined) {
        return <AnswerForm formHandler={formHandler} />;
      } else {
        console.warn(`AnswerForm with type '${processType}' doesn't exists.`);
      }
    }
  };

  // render
  return (
    <div>
      <ContractingProcessType
        bindCheckField={formHandler.bindCheckField}
        errors={formHandler.errors}
      />
      {renderProcessAnswerForm()}
      <RenderWrapper isVisible={() => isFilledProcessType(getProcessType())}>
        <div className="row mx-n2">
          <div className="col-lg-6 px-2">
            <ContractExpectedEffectiveDate
              formHandler={formHandler}
              terminationSchemes={terminationSchemes}
            />
          </div>
          <div className="col-lg-6 px-2">
            <RenderWrapper
              isVisible={() => isInvoiceUploadType(getProcessType())}
            >
              <InvoiceUploadSubForm formHandler={formHandler} />
            </RenderWrapper>
          </div>
        </div>
      </RenderWrapper>
      <ContractingFooter
        onPrevClick={onPrevClick}
        onNextClick={onNextClick}
        onSaveClick={props.enableSaveBtn ? onSaveClick : undefined}
      />
    </div>
  );
};

export default ProcessFormSection;
